export default ['darkblue', 'blue', 'cornflowerblue', 'lightblue'];
